import {boldCar, arrowDown, shieldProtected, infoIcon} from '@img/index.js'
import {formatDurationHM} from '@/utils/dateUtils'
import {formatBufferApprox} from '@/utils/policyFormat'
import {formatSmartTime} from '@/utils/smartTime'
import {waitingItemImage} from './waitingIcons'

// toAirport recommended-pickup card (the expandable breakdown). Identical in the booking
// step and the edit/confirm DateTimeSection; the only difference is the "total time" info
// icon — booking opens a Liability Disclaimer via `onLiabilityInfo`, edit renders a bare icon.
//
// The breakdown is data-driven: `waitingItems` are the airport's own waiting_times rows
// from /config/airports, `airportBuffer` the cushion they total to, and
// `arriveEarlyMinutes` that cushion minus its road allowance (see utils/smartTime
// airportContext). Our drive-time row stays at the top — the backend can't know it.
export default function ToAirportRecommendedCard({
    calc, expanded, onToggle, onLiabilityInfo,
    waitingItems = [], airportBuffer = 0, arriveEarlyMinutes = 0,
}) {
    if (!calc) return null
    return (
        <div className="hopn-pickup-options to-airport">
            <div className="hopn-pickup-options-grid">
                <div className="hopn-pickup-options-grid-col">
                    <div className={`hopn-pickup-option recommended selected ${expanded ? 'expanded' : ''}`}>
                        <div className="recommendation-tabs">
                            <button type="button" className="recommendation-list" onClick={onToggle}>
                                <span><img src={boldCar} alt=""/></span>
                                <div className="recommendation-content">
                                    <div className="recommendation-content-list">
                                        <h3>Recommended pickup
                                            <span>
                                                {formatSmartTime(calc.recommendedTime)}
                                                <em className="local"> | {formatDurationHM(calc.travelMinutes)} drive</em>
                                            </span>
                                        </h3>
                                        <img className={`expand-arrow ${expanded ? 'expanded' : ''}`} src={arrowDown} alt=""/>
                                    </div>
                                </div>
                            </button>
                            {expanded && (
                                <div className="recommendation-content-data">
                                    <div className="hopn-why-pickup-time">
                                        <div className="hopn-why-pickup-time-icon"><img src={shieldProtected} alt=""/></div>
                                        <div className="hopn-why-pickup-time-text">
                                            <h6>Why this pickup time?</h6>
                                            <p>We recommend arriving at the airport about {formatBufferApprox(arriveEarlyMinutes)} before your flight departure</p>
                                        </div>
                                    </div>
                                    <ul className="hopn-pickup-breakdown-list">
                                        <li>
                                            <span className="hopn-breakdown-icon"><img src={boldCar} alt=""/></span>
                                            <span className="hopn-breakdown-label">Travel time to airport <em>(Traffic dependent)</em></span>
                                            <span className="hopn-breakdown-value">~{formatDurationHM(calc.travelMinutes)}</span>
                                        </li>
                                        {waitingItems.map((item, i) => (
                                            <li key={i}>
                                                <span className="hopn-breakdown-icon"><img src={waitingItemImage(item.name)} alt=""/></span>
                                                <span className="hopn-breakdown-label">{item.name}</span>
                                                <span className="hopn-breakdown-value">~{formatBufferApprox(item.minutes)}</span>
                                            </li>
                                        ))}
                                    </ul>
                                    <p className="hopn-pickup-total">
                                        <span className="hopn-pickup-total-label"><strong>Total</strong> recommended time:</span>
                                        <span className="hopn-pickup-total-value">
                                            {/* Cushion + our drive leg — the same figures the rows show. */}
                                            ~{formatBufferApprox(airportBuffer + (calc.travelMinutes || 0))} before departure
                                            {onLiabilityInfo
                                                ? <button type="button" className="hopn-info-icon" onClick={onLiabilityInfo}><img src={infoIcon} alt="Liability disclaimer"/></button>
                                                : <img src={infoIcon} alt=""/>}
                                        </span>
                                    </p>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
